import { Module } from '../Module';

/**
 * Adds 'tb-disabled' class to an element if the tb-disabled expression evaluates to true.
 *
 * If the element specifies a tabindex, remove the tabindex while the element is disabled
 *
 * Usage:
 *
 *   span.tb-outline-button(tb-disabled="isDisabled()")
 *
 */
Module.instance().directive('tbDisabled', <any[]>[
  () => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        const tabindex = element.attr('tabindex');
        const isTabindexSet = tabindex !== '-1';

        scope.$watch(attr['tbDisabled'], (disabled: boolean) => {

          // Must coerce to boolean for toggleClass to work correctly
          disabled = !!disabled;
          element.toggleClass('tb-disabled', disabled);
          element.prop('disabled', disabled);
          if(isTabindexSet) {
            if (disabled) {
              element.removeAttr('tabindex');
            } else {
              element.attr('tabindex', tabindex);
            }
          }
        });
      }
    };
  }
]);
